<div class="doNotPrint">
<div class="row">
  <div class="col-xs-1 col-sm-1 col-md-5 col-lg-5">
  </div>
  <div class="col col-xs-10  col-sm-10 col-md-5 col-lg-5">
    <p class="h8"><b>Drug Search</b></p>
  </div>
  <div class="col-xs-1 col-sm-1 col-md-2 col-lg-2">
  </div>
</div>
<div class="row">
  <div class="col-xs-0  col-sm-0 col-md-4 col-lg-4">
  </div>
  <div class="col col-xs-12  col-sm-12 col-md-7 col-lg-7">
    <div class="btn-group btn-group-toggle">
      <label class="btn-primary" ngbButtonLabel [ngClass]="isSearchByDrug ? 'active' : 'not-active'">
        <input type="checkbox" id="searchByDrug" ngbButton (click)="searchByDrug()" >Search By Drug
      </label>
      <label class="btn-primary" ngbButtonLabel  [ngClass]="isSearchByDrug ? 'not-active' : 'active'">
        <input type="checkbox" id="searchByClass" ngbButton (click)="searchByDrugClass()">Search By Drug Class
      </label>
    </div>
  </div>
</div>
<br>
<div *ngIf="isSearchByDrug">
  <div class="row">
    <div class="col col-xs-12  col-sm-12 col-md-4 col-lg-4">
    </div>
    <div class="col col-xs-12  col-sm-12 col-md-8 col-lg-8">
      <p><b>To begin your search, enter drug name:</b></p>
    </div>
  </div>
  <form name="SearchByDrug">
  <div class="row">
    <div class="col col-xs-12  col-sm-12 col-md-4 col-lg-4">
    </div>
    <div class="input-group col col-xs-12  col-sm-12 col-md-3 col-lg-3">
      <input type="text" class="form-control toUpperCaseTransform" name="brandOrGenericValue"  (selectItem)="selectedItem($event)" [ngbTypeahead]="search" [(ngModel)]="brandOrGenericValue"
      placeholder="Drug name*" required>
    </div>
    <br>

    <div class="col col-xs-12  col-sm-12 col-md-3 col-lg-3">
      <button  class="btn btn-primary" (keyup.enter) = "searchByDrugName()" (click)="searchByDrugName()"
        [disabled]="brandOrGenericValue?.length <3 || !enableSearch">Search</button>
    </div>
  </div>
  </form>
</div>
<div *ngIf="!isSearchByDrug">
  <div class="row">
    <div class="col-md-4 col-lg-4">
    </div>
    <div class="col col-xs-12  col-sm-12 col-md-8 col-lg-8">
      <p class="h8"><b>Select the Therapeutic Category and Class</b></p>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2">
    </div>
    <div class="col col-xs-12  col-sm-12 col-md-3 col-lg-3">
      <select class="form-control" aria-label="State" name= "category" [(ngModel)]="category" (change)="onCategorySelectionChange()" required>
        <option selected hidden>Category*</option>
        <option  [value]="drugSearchCategoryDetails.therCat1Nm" data-toggle="tooltip" data-placement="top" title= {{drugSearchCategoryDetails.categoryDisplayValue}} *ngFor="let drugSearchCategoryDetails of drugSearchCategoryDetailsList">{{drugSearchCategoryDetails.categoryDisplayValue}}</option>
      </select>
    </div>
    <div class="col col-xs-12  col-sm-12 col-md-3 col-lg-3">
      <select class="form-control" aria-label="State" name= "class" [(ngModel)]="class"  required [disabled]="drugSearchClassDetailsList.length === 0">
        <option selected hidden>Class*</option>
        <option  [value]="drugSearchClassDetails.therClass1Nm"  data-toggle="tooltip" data-placement="top" title= {{drugSearchClassDetails.classDisplayValue}} *ngFor="let drugSearchClassDetails of drugSearchClassDetailsList">{{drugSearchClassDetails.classDisplayValue}}</option>
      </select>
    </div>
    <div class="col col-xs-12  col-sm-12 col-md-3 col-lg-3">
      <button type="button" class="btn btn-primary" (click)="searchByTCCClass()"
        [disabled]="(category ==='Category*' || class ==='Class*' || drugSearchClassDetailsList.length === 0)">Search</button>
    </div>
  </div>
</div>
</div>
<br>
<div class="row align-results-label-heading">
  <div class="col-md-12 col-lg-12">
    <p class="h8" *ngIf="showDrugSearchResults && planDetails?.drugSearchType != 'searchByDrugClass'">To view search results, click the arrow drop down and select a drug to view formulary coverage. Please note that brand drugs will display in all capitalized letters and generic drugs
      will display in all lower case letters.</p>
  </div>
  <p class="h8" *ngIf="showDrugSearchResults && planDetails?.drugSearchType === 'searchByDrugClass'">To view search results, click the arrow drop down and select a drug to view formulary coverage. Please note that non-formulary drugs are not shown in this view. Brand drugs will display in all capitalized letters and generic drugs will display in all lower case letters.</p>
</div>
<app-drug-results  *ngIf="showDrugSearchResults" [searchByDrugNameMap]=searchByDrugNameMap [isBrandOrGeneric]=isBrandOrGeneric></app-drug-results>

<div class="card card-border doNotPrint" *ngIf="displayNoFormularyDrugs">
  <div class="card-body">
    <div class="row">
      <div class="col-md-1 col-lg-1">
      </div>
      <div class=" col col-xs-4  col-sm-4 col-md-4 col-lg-4">
        <p class="h8 align-serach-results-label"><b>Search Results</b></p>
      </div>
    </div>
    <div>
      <div class="alert alert-danger alert-dismissible">
        <span>{{displayNoFormularyDrugsMessage}}</span>
      </div>
    </div>
  </div>
</div>
